/**
 * Chatbot Service - Main Entry Point
 * Re-exports all service modules for backward compatibility
 *
 * This service has been refactored into modular components:
 * - utils/apiConfig.js - API configuration
 * - utils/authHelper.js - Authentication utilities
 * - services/chatService.js - Chat operations
 * - services/questionService.js - Question management
 * - services/promptService.js - Prompt management
 * - services/healthService.js - Health checks and debugging
 */

import { chatService } from './services/chatService';
import { questionService } from './services/questionService';
import { promptService } from './services/promptService';
import { healthService } from './services/healthService';
import { getAccessToken } from './utils/authHelper';

/**
 * Unified chatbot service object
 * Maintains backward compatibility with existing code
 */
export const chatbotService = {
    // ==================== Authentication ====================
    getAccessToken,

    // ==================== Chat Operations ====================
    sendMessage: chatService.sendMessage.bind(chatService),
    sendMessageStream: chatService.sendMessageStream.bind(chatService),

    // ==================== Question Operations ====================
    fetchQuestionData: questionService.fetchQuestionData.bind(questionService),
    seedQuestionById: questionService.seedQuestionById.bind(questionService),
    verifyCurrentQuestion: questionService.verifyCurrentQuestion.bind(questionService),
    initializeForQuestion: questionService.initializeForQuestion.bind(questionService),

    // ==================== Prompt Management ====================
    getCurrentPrompt: promptService.getCurrentPrompt.bind(promptService),
    getDefaultPrompt: promptService.getDefaultPrompt.bind(promptService),
    setSessionPrompt: promptService.setSessionPrompt.bind(promptService),
    clearSessionPrompt: promptService.clearSessionPrompt.bind(promptService),

    // ==================== Health & Debug ====================
    healthCheck: healthService.healthCheck.bind(healthService),
    checkMainBackend: healthService.checkMainBackend.bind(healthService),
    getConfig: healthService.getConfig.bind(healthService),
    testConnections: healthService.testConnections.bind(healthService),
    debugEndpoints: healthService.debugEndpoints.bind(healthService),
};

// Default export for backward compatibility
export default chatbotService;
